/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Product sources
 * @export
 * @enum {string}
 */

export const Source = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;

export type Source = typeof Source[keyof typeof Source];



